import { createSpaAuth, type SpaAuth } from "@coten-inc/coten-auth-spa";

import { config } from "~/config";

import { connectIntegration } from "./connectAuth";

export const createDeweyAuth = (): Promise<SpaAuth> =>
  createSpaAuth({
    environment: config.cotenAuth.environment,
    clientId: config.cotenAuth.clientId,
    ...(config.cotenAuth.authenticationEmulatorClientId === undefined
      ? {}
      : { authenticationEmulatorClientId: config.cotenAuth.authenticationEmulatorClientId }),
    ...(config.cotenAuth.cotenIdApiOrigin === undefined ? {} : { cotenIdApiOrigin: config.cotenAuth.cotenIdApiOrigin }),
    ...(connectIntegration ? { integrations: [connectIntegration] } : {}),
    ...(config.cotenAuth.authenticationApiOrigin === undefined
      ? {}
      : {
          authenticationApiOrigin: config.cotenAuth.authenticationApiOrigin,
        }),
    redirectUri: `${window.location.origin}/callback`,
    logoutRedirectUri: `${window.location.origin}/signed-out`,
    apiOrigins: [new URL(config.graphqlEndpoint).origin, new URL(config.cnutGraphqlEndpoint).origin],
  });
